import React, { FC, ReactNode } from 'react';

interface MobileBookingSectionProps {
  step: number
  label: string
  /** The patient's choice, or null to show the placeholder. */
  value: string | null
  placeholder: string
  subValue?: string
  done: boolean
  open: boolean
  onOpen: () => void
  children: ReactNode
}

/** One step of the mobile accordion: a header showing the choice, and its picker. */
export const MobileBookingSection: FC<MobileBookingSectionProps> = ({
  step,
  label,
  value,
  placeholder,
  subValue,
  done,
  open,
  onOpen,
  children,
}) => (
  <section className={`adhd-booking-section ${open ? 'active' : ''} ${done ? 'done' : ''}`}>
    <button type="button" className="adhd-booking-section__hd" onClick={onOpen}>
      <span className="adhd-booking-section__idx">
        {done && !open ? '✓' : String(step)}
      </span>
      <span className="adhd-booking-section__txt">
        <span className="adhd-booking-section__k">{label}</span>
        <span className={`adhd-booking-section__v ${value ? '' : 'empty'}`}>
          {value || placeholder}
        </span>
        {subValue && <span className="adhd-booking-section__v2">{subValue}</span>}
      </span>
      {!open && done && (
        <span className="adhd-booking-section__act">Change</span>
      )}
    </button>
    <div className="adhd-booking-section__bd">
      {children}
    </div>
  </section>
);

interface DesktopStepHeadingProps {
  step: number
  title: string
}

export const DesktopStepHeading: FC<DesktopStepHeadingProps> = ({ step, title }) => (
  <div className="flex items-center gap-2 mb-3">
    <span className="w-5 h-5 rounded-full text-white text-xs font-bold flex items-center justify-center bg-brand">{step}</span>
    <span className="text-sm font-bold text-slate-700">{title}</span>
  </div>
);
